'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentLayupAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M31.3246 21.2007L29.7046 30.4525H34.2596L33.7478 33.3186H25.6259L27.7597 21.2046L31.3246 21.2007Z",
          fill: "#0C4152"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M35.0275 31.1473C35.017 30.7803 35.088 30.4155 35.2354 30.0793C35.3828 29.743 35.6029 29.4435 35.8799 29.2025C36.5629 28.6395 37.7401 28.3147 39.2065 28.2183L41.1868 28.0824L41.238 27.6552C41.3227 26.9899 41.0156 26.6494 40.3502 26.6494C39.7873 26.6494 39.3778 26.8876 39.2932 27.673H35.9271C36.0984 26.1888 37.1397 24.5845 40.4821 24.5845C43.6218 24.5845 44.9702 25.984 44.5431 28.4407L44.0647 31.2221C43.9381 31.9141 43.8815 32.6172 43.8954 33.3205H40.5884C40.5752 32.9026 40.6095 32.4846 40.6908 32.0745C40.2656 33.0292 39.1908 33.5253 37.8759 33.5253C36.1869 33.5194 35.0275 32.6827 35.0275 31.1473ZM40.9132 30.293L41.0333 29.5607L40.179 29.6119C38.9507 29.6789 38.5767 30.2025 38.5767 30.7202C38.5767 31.2832 39.053 31.4721 39.5314 31.4721C39.8688 31.4897 40.2001 31.3772 40.4572 31.1579C40.7142 30.9385 40.8774 30.629 40.9132 30.293Z",
          fill: "#0C4152"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M44.0354 36.4698L44.4626 34.1076C44.9305 34.2565 45.4207 34.3231 45.9114 34.3045C46.4232 34.3045 46.9704 34.1076 47.1909 33.5368L47.2932 33.2632L45.6043 24.7673H49.2224L49.494 29.527C49.5299 29.8545 49.5247 30.1851 49.4782 30.5113H49.5295C49.598 30.1756 49.6948 29.8463 49.8188 29.527L51.7125 24.7673H55.2439L50.7164 33.7592C49.3188 36.5151 47.7145 36.7119 46.0079 36.7119C45.3421 36.7285 44.6775 36.6469 44.0354 36.4698Z",
          fill: "#0C4152"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M59.1162 28.486C58.7913 30.3108 59.7818 30.7714 60.6912 30.7714C62.0218 30.7714 62.5511 29.7872 62.705 28.8954L64.0532 21.2007H67.6201L66.1533 29.543C65.8465 31.3009 64.5493 33.604 60.5061 33.604C57.6399 33.604 54.8762 32.4446 55.6262 28.1277L56.8387 21.2007H60.3959L59.1162 28.486Z",
          fill: "#1BBCC0"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M78 28.3211C78 30.4195 76.7027 32.7048 72.2675 32.7048H70.2989L69.5887 36.7993H66.0233L68.1551 24.6794H73.1888C75.6279 24.6794 78 25.4668 78 28.3211ZM74.1944 28.4746C74.1944 27.2935 73.2398 27.1597 72.541 27.1597H71.2952L70.732 30.3093H71.9784C73.598 30.3171 74.1944 29.4038 74.1944 28.4746Z",
          fill: "#1BBCC0"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M9.61673 29.116C9.62657 29.0707 13.2072 22.9448 13.2072 22.9448H10.9277C10.6848 22.9453 10.4468 23.0131 10.2401 23.1406C10.0333 23.2681 9.86594 23.4504 9.75649 23.6672C9.66759 23.8445 9.62046 24.0398 9.6187 24.2381L9.61673 29.116Z",
          fill: "#1BBCC0"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M6.31947 26.7537L8.54188 30.5115L8.51629 24.9683H7.35685C7.20004 24.968 7.04471 24.9987 6.89975 25.0585C6.75479 25.1183 6.62306 25.2062 6.51208 25.317C6.4011 25.4278 6.31306 25.5593 6.25298 25.7042C6.19291 25.8491 6.16199 26.0043 6.16199 26.1612C6.16142 26.3691 6.21574 26.5735 6.31947 26.7537Z",
          fill: "#A9D9DC"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M9.82731 31.6746C9.8266 31.8508 9.85589 32.0259 9.91393 32.1923L9.93164 32.2435V32.2593C9.94536 32.2962 9.96113 32.3323 9.97889 32.3675C10.0502 32.5192 10.146 32.6582 10.2623 32.7789C10.4088 32.9357 10.5854 33.0611 10.7816 33.1477C10.9779 33.2343 11.1896 33.2803 11.4041 33.2828H17.9138C18.1389 33.2828 18.361 33.2312 18.563 33.1319C18.7651 33.0325 18.9416 32.8883 19.0791 32.71L24.4747 23.5822L24.5869 23.3854C24.6984 23.1607 24.7508 22.9113 24.739 22.6608C24.7273 22.4103 24.6518 22.1669 24.5198 21.9537C24.3877 21.7404 24.2035 21.5644 23.9845 21.4422C23.7654 21.3201 23.5189 21.2558 23.268 21.2555H16.5634C16.3243 21.2556 16.0887 21.3139 15.8772 21.4254C15.6656 21.5368 15.4842 21.6981 15.3489 21.8952L15.2465 22.0685L9.98479 30.9778C9.95861 31.0349 9.93562 31.0934 9.91589 31.153C9.89625 31.2097 9.87982 31.2676 9.86668 31.3262C9.84022 31.4404 9.82702 31.5574 9.82731 31.6746Z",
          fill: "#0C4152"
        }
      )
    ]
  }
);
const VpPaymentLayupAsset = forwardRef(PaymentLayupAsset);

export { VpPaymentLayupAsset as default };
